export const USER_PROFILE_LOADED = 'IMP/USER_PROFILE_LOADED';
export const USER_PROFILE_LOADING = 'IMP/USER_PROFILE_LOADING';
export const HANDLE_AUTHENTICATION_CALLBACK = 'IMP/HANDLE_AUTHENTICATION_CALLBACK';
export const SILENT_AUTH_CHECK = 'IMP/SILENT_AUTH_CHECK';
export const USER_CHECK = 'IMP/USER_CHECK';
export const AUTH0_LOADED = 'IMP/AUTH0_LOADED';
export const LOGIN_REQUIRED = 'IMP/LOGIN_REQUIRED';

export function handleAuthenticationCallback(payload) {
  return {
    type: HANDLE_AUTHENTICATION_CALLBACK,
    payload: payload
  };
}

export function silentAuthCheck(forceLogin = false) {
  return {
    type: SILENT_AUTH_CHECK,
    forceLogin: forceLogin
  };
}

export const userCheck = (payload, pathName, routeParams) => ({
  type: USER_CHECK,
  payload: {
    ...payload,
    routeParams,
  },
  meta: { auth: true, pathName },
});

////////////////////

export const SIGN_IN = 'IMP/SIGN_IN';
export const SIGN_IN_ATTEMPT = 'IMP/SIGN_IN_ATTEMPT';
export const SIGN_IN_SUCCESS = 'IMP/SIGN_IN_SUCCESS';
export const SIGN_IN_FAILURE = 'IMP/SIGN_IN_FAILURE';
export const signIn = (email) => ({
  type: SIGN_IN,
  email: email
});
export const SIGN_OUT = 'IMP/SIGN_OUT';
export const SIGN_OUT_SUCCESS = 'IMP/SIGN_OUT_SUCCESS';
export const signOut = () => ({
  type: SIGN_OUT
});

/* export const USER_LOGIN = 'SF/USER_LOGIN';
export const USER_LOGIN_LOADING = 'SF/USER_LOGIN_LOADING';
export const USER_LOGIN_FAILURE = 'SF/USER_LOGIN_FAILURE';
export const USER_LOGIN_SUCCESS = 'SF/USER_LOGIN_SUCCESS';

export const userLogin = (payload, pathName) => ({
  type: USER_LOGIN,
  payload,
  meta: { auth: true, pathName }
});

export const USER_CHECK = 'SF/USER_CHECK';
export const USER_CHECK_SUCCESS = 'SF/USER_CHECK_SUCCESS';

export const userCheck = (payload, pathName, routeParams) => ({
  type: USER_CHECK,
  payload: {
    ...payload,
    routeParams
  },
  meta: {auth: true, pathName}
});

export const USER_LOGOUT = 'SF/USER_LOGOUT';
export const userLogout = (redirectTo) => ({
  type: USER_LOGOUT,
  payload: { redirectTo },
  meta: { auth: true }
});

export const AUTH_LOGIN = 'SF/AUTH_LOGIN';
export const AUTH_CHECK = 'SF/AUTH_CHECK';
export const AUTH_ERROR = 'SF/AUTH_ERROR';
export const AUTH_LOGOUT = 'SF/AUTH_LOGOUT';
export const AUTH_GET_PERMISSIONS = 'SF/AUTH_GET_PERMISSIONS';
*/
